import React, { useContext, useEffect, useState } from 'react'
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';

import './styles.css'
import { deckViewerStrings } from '../../utils';
import { Button } from '../../components';
import { getUserDeckById } from '../../services';
import { LoadingContext, LoadingContextType } from '../../contexts';

const Deckviewer = () => {
    const { isLoading, setLoading } = useContext<LoadingContextType>(LoadingContext);
    const [searchParams] = useSearchParams();
    const [decklist, setDecklist] = useState('');
    const [maybeboard, setMaybeboard] = useState('');
    const [title, setTitle] = useState<string>('')
    const [version, setVersion] = useState<string>('')
    const [description, setDescription] = useState<string>('')
    const [id, setId] = useState<string>('')
    const [viewMode] = useState<string>('list')
    const navigate = useNavigate()

    useEffect(() => {
        setLoading(true)
        const id = searchParams.get("deckId")

        if (!id) {
            return
        }
        
        getUserDeckById(id).then(deck => {
            setLoading(false)
            if (!deck) return
            setVersion(deck.version)
            setTitle(deck.title)
            setDescription(deck.description)
            setDecklist(deck.decklist)
            setMaybeboard(deck.maybeboard)
            setId(deck.id!)
        });
    }, [searchParams])

    const editDeckHandler = (deckId: string) => {
        const params = { deckId };

        if (deckId)
            navigate({
                pathname: '/deckbuilder',
                search: `?${createSearchParams(params)}`,
            })
    }

    const cardsView = (list: string) => {
        switch (viewMode) {
            case 'list':
                return <pre>{list}</pre>
        }
    }

    return (
        <>
            { title
                ? <div className='deckviewer-wrapper'>
                    <h1>{title}</h1>
                    <h2>{deckViewerStrings.version}{version}</h2>
                    <div>
                        {deckViewerStrings.description}
                        <pre>{description}</pre>
                    </div>
                    <div>
                        {deckViewerStrings.decklist}
                        {cardsView(decklist)}
                    </div>
                    <div>
                        {deckViewerStrings.maybeboard}
                        {cardsView(maybeboard)}
                    </div>
                    <Button onClick={() => editDeckHandler(id)}>
                        {deckViewerStrings.editPageButton}
                    </Button>
                </div>
                : <></>
            }
        </>
    )
}

export default Deckviewer
